import { login, resetPwdSendCode, resetPwdConfirm, loginSendCode, loginByCode, getPasswordCodeSrc } from '../../../api/user-api.js'
export default {
  data() {
    return {
      status: 'login',
      isPasswordLogin: false,
      codeImg: '',
      code: '',
      password: '',
      phone: '',
      loginCode: '',
      isLoading: false,
      loginBeforePathAndSerach: '',
      forgetpwdForm: {
        phone: '',
        password: '',
        againPassword: '',
        code: ''
      },
      loginSendCodeTimeInfo: {
        time: 0,
        timer: null
      },
      passwordSendCodeTimeInfo: {
        time: 0,
        timer: null
      },
      savePassword: false
    }
  },
  computed: {
    statusText() {
      return this.status === 'login' ? '登录' : '重置密码'
    },
    loginTypeChangeText() {
      return this.isPasswordLogin ? '短信登录' : '密码登录'
    }
  },
  created() {
    const query = this.$route.query
    if (query && query.from) {
      this.loginBeforePathAndSerach = decodeURIComponent(query.from)
    }
    if (query && query.token) {
      this.loginAfterHandle(query.token)
      return
    }
    if (localStorage.getItem('login-password')) {
      this.password = localStorage.getItem('login-password') || ''
    }
    this.refreshCode()
    const loginTime = parseInt(localStorage.getItem('login-send-code-time'))
    const passwordTime = parseInt(localStorage.getItem('password-send-code-time'))
    this.sendCodeTimeHandle(loginTime, this.loginSendCodeTimeInfo)
    this.sendCodeTimeHandle(passwordTime, this.passwordSendCodeTimeInfo)
  },
  methods: {
    sendCodeTimeHandle(time, timeInfo) {
      if (isNaN(time)) {
        return
      }
      const nowTime = new Date().getTime()
      if (time && time + 60 * 1000 > nowTime) {
        timeInfo.time = parseInt((time + 60 * 1000 - nowTime) / 1000)
        if (timeInfo.time) {
          timeInfo.timer = setInterval(() => {
            timeInfo.time--
            if (!timeInfo.time) {
              clearInterval(timeInfo.timer)
            }
          }, 1000)
        }
      }
    },
    inputPhone() {
      this.phone = this.phone.replace(/[^\d]/ig, '')
    },
    inputPwdPhone() {
      this.forgetpwdForm.phone = this.forgetpwdForm.phone.replace(/[^\d]/ig, '')
    },
    inputCode() {
      this.code = this.code.replace(/[^\w]/ig, '')
    },
    inputPwdCode() {
      this.forgetpwdForm.code = this.forgetpwdForm.code.replace(/[^\w]/ig, '')
    },
    changeLoginType() {
      this.isPasswordLogin = !this.isPasswordLogin
    },
    async loginSendCode() {
      if (this.loginSendCodeTimeInfo.time || this.isLoading) {
        return
      }
      if (!this.phone) {
        this.$message.error('请输入11位手机号')
        return
      }
      if (this.phone.length !== 11) {
        this.$message.error('请输入11位手机号')
        return
      }
      this.isLoading = true
      try {
        await loginSendCode({ phone: this.phone })
        localStorage.setItem('login-send-code-time', new Date().getTime())
        this.loginSendCodeTimeInfo.time = 60
        this.loginSendCodeTimeInfo.timer = setInterval(() => {
          this.loginSendCodeTimeInfo.time--
          if (!this.loginSendCodeTimeInfo.time) {
            clearInterval(this.loginSendCodeTimeInfo.timer)
          }
        }, 1000)
      } catch (error) {
      }
      this.isLoading = false
    },
    gotoLogin() {
      this.status = 'login'
      this.phone = ''
      this.password = ''
      this.code = ''
      this.refreshCode()
    },
    goLoginForgetpwd() {
      this.forgetpwdForm = {
        phone: '',
        password: '',
        againPassword: '',
        code: ''
      }
      this.status = 'forget'
    },
    async refreshCode() {
      if (this.codeImg) {
        URL.revokeObjectURL(this.codeImg)
      }
      this.codeImg = await getPasswordCodeSrc()
    },
    goLogin() {
      if (this.isPasswordLogin) {
        this.loginByPassword()
      } else {
        this.loginByCode()
      }
    },
    async loginByPassword() {
      if (!this.phone) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (this.phone.length !== 11) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (!this.password) {
        this.$message.error('请输入密码')
        return
      }
      if (this.password.length < 6 || this.password.length > 24) {
        this.$message.error('密码长度需要为6~24位')
        return
      }
      if (!this.code) {
        this.$message.error('请输入4位验证码')
        return
      }
      if (this.code.length !== 4) {
        this.$message.error('请输入4位验证码')
        return
      }
      this.isLoading = true
      try {
        const res = await login({ phone: this.phone, cipher: this.password, graphicCode: this.code })
        this.loginAfterHandle(res.token)
      } catch (e) {
        this.refreshCode()
        this.code = ''
      }
      this.isLoading = false
    },
    async loginByCode() {
      if (!this.phone) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (this.phone.length !== 11) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (!this.loginCode) {
        this.$message.error('请输入6位验证码')
        return
      }
      if (this.loginCode.length !== 6) {
        this.$message.error('请输入6位验证码')
        return
      }
      this.isLoading = true
      try {
        const res = await loginByCode({ phone: this.phone, smsCode: this.loginCode })
        this.loginAfterHandle(res.token)
      } catch (e) {
        this.loginCode = ''
      }
      this.isLoading = false
    },
    loginAfterHandle(token) {
      localStorage.setItem('token', token)
      // 有登录前的链接数据
      if (this.loginBeforePathAndSerach && this.loginBeforePathAndSerach !== '/') {
        let adminUrl = process.env.VUE_APP_ADMIN_URL
        if (this.loginBeforePathAndSerach.indexOf('?') !== -1) {
          // 有其他参数
          adminUrl = `${adminUrl}${this.loginBeforePathAndSerach}&token=${token}`
        } else {
          adminUrl = `${adminUrl}${this.loginBeforePathAndSerach}?token=${token}`
        }
        this.isLoading = false
        window.location.href = adminUrl
        localStorage.removeItem('login-send-code-time')
        return
      }
      this.$router.push('/workbench')
    },
    async resetPwd() {
      if (!this.forgetpwdForm.phone) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (this.forgetpwdForm.phone.length !== 11) {
        this.$message.error('请输入11位手机号码')
        return
      }
      if (!this.forgetpwdForm.code) {
        this.$message.error('请输入6位验证码')
        return
      }
      if (this.forgetpwdForm.code.length !== 6) {
        this.$message.error('请输入6位验证码')
        return
      }
      if (!this.forgetpwdForm.password) {
        this.$message.error('请输入重置密码！')
        return
      }
      if (this.forgetpwdForm.password.length < 6) {
        this.$message.error('重置密码长度至少为6位')
        return
      }
      if (!this.forgetpwdForm.againPassword) {
        this.$message.error('请输入确认重置密码！')
        return
      }
      if (this.forgetpwdForm.password !== this.forgetpwdForm.againPassword) {
        this.$message.error('两次输入的密码不相同！')
        return
      }
      this.isLoading = true
      try {
        await resetPwdConfirm({ phone: this.forgetpwdForm.phone, password: this.forgetpwdForm.password, code: this.forgetpwdForm.code })
        this.$message.success('重置成功！')
        localStorage.removeItem('password-send-code-time')
        this.gotoLogin()
      } catch (e) {
      }
      this.isLoading = false
    },
    async sendCode() {
      if (this.passwordSendCodeTimeInfo.time || this.isLoading) {
        return
      }
      if (!this.forgetpwdForm.phone) {
        this.$message.error('请输入11位手机号')
        return
      }
      if (this.forgetpwdForm.phone.length !== 11) {
        this.$message.error('请输入11位手机号')
        return
      }
      this.isLoading = true
      try {
        await resetPwdSendCode({ phone: this.forgetpwdForm.phone })
        localStorage.setItem('password-send-code-time', new Date().getTime())
        this.passwordSendCodeTimeInfo.time = 60
        this.passwordSendCodeTimeInfo.timer = setInterval(() => {
          this.passwordSendCodeTimeInfo.time--
          if (!this.passwordSendCodeTimeInfo.time) {
            clearInterval(this.passwordSendCodeTimeInfo.timer)
          }
        }, 1000)
      } catch (error) {
      }
      this.isLoading = false
    }
  }
}
